import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class SkuDetails{
@ApiProperty()
skuCodeId: number;
@ApiProperty()
multipleVarientCode : number[];

@ApiProperty()
isActive: boolean;

createdAt : Date;

@ApiProperty()
@IsOptional()
@MaxLength(40, { message: "Created User allows maximum 40 characters" })
@Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
createdUser : string;

updatedAt : Date;
@ApiProperty()
@IsOptional()
@MaxLength(40, { message: "Updated User allows maximum 40 characters"})
@Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
updatedUser : string;

@ApiProperty()
versionFlag : number;
}